// extracted by mini-css-extract-plugin
module.exports = {"transfer":"_2PmEVy7dIaGT","transfer__layover":"rrTAuEZ5x6IH","warning":"_3Shlh56QPx-m","warning_red":"_3-EVNb1goffZ"};